import React from "react";

function RouteIndicator(props) {
  const routeIcons =
    props.routeList && props.routeList.length
      ? props.routeList.map((route) => {
          const routeNumber = route.replace(/\D/g, "");
          const backgroundColour = props.routeColours[routeNumber]
            ? props.routeColours[routeNumber].PIDColour
            : "";
          const textColour = props.routeColours[routeNumber]
            ? props.routeColours[routeNumber].TextColour
            : "";
          return (
            <div
              className="route-indicator-item "
              style={{
                backgroundColor: backgroundColour,
                color: textColour,
              }}
              key={route}
            >
              <span>{route}</span>
            </div>
          );
        })
      : "";

  return <div className="route-indicator">{routeIcons}</div>;
}

export default RouteIndicator;
